var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex py-3",attrs:{"id":"google-recaptcha"}})}
var staticRenderFns = []

export { render, staticRenderFns }